import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { PasswordModule } from 'primeng/password';
import { DropdownModule } from 'primeng/dropdown';
import { LanguageService } from '@app/shared/services/language.service';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TranslateModule } from '@ngx-translate/core';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { PanelModule } from 'primeng/panel';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { RecaptchaModule } from "ng-recaptcha-2";
import { NgOtpInputModule } from 'ng-otp-input';
import { SuperAdminLoginDialogComponent } from './super-admin-login-dialog/super-admin-login-dialog.component';


@NgModule({
  declarations: [
    LoginComponent,
    SuperAdminLoginDialogComponent
  ],
  imports: [
    CommonModule,
    LoginRoutingModule,
    ButtonModule,
    CheckboxModule,
    InputTextModule,
    RecaptchaModule,
    FormsModule,
    PasswordModule,
    PanelModule,
    DropdownModule,
    SelectButtonModule,
    TranslateModule,
    ToastModule,
    ToggleButtonModule,
    ReactiveFormsModule,
    DialogModule,
    NgOtpInputModule
  ],
  providers: [
    LanguageService
  ]
})
export class LoginModule { }
